<template lang="pug">
.v-modal-map.modal-map
	.modal-map__map(id='map-modal')

</template>

<script>
import { Loader } from "@googlemaps/js-api-loader"
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import uniqueId from '../scripts/helpers/uniqueId.js';


export default {
	mixins: [sourceMixin],
	emits: [
		'set-position'
	],

	data() {
		return {
			localValue: null,
			position: null,
			zoom: null,
			confirmed: null,
			marker: null,
			items: null,
			uniqueId: uniqueId('field-'),
		};
	},

	methods: {
		dataSet(data) {
			this.position = data.position;
			this.zoom = data.zoom;
			this.confirmed = data.confirmed;
			this.marker = data.marker;
			this.language = data.language;
			this.items = data.items
			this.initMap();
		},

		initMap() {
			const loader = new Loader({
				apiKey: "AIzaSyAci1VG7P-E3ci2nPTSgIuLbAGH9PXGANI",
				version: "weekly",
				language: this.language || "en"
			});
			loader.load().then(async () => {
				const { Map } = await google.maps.importLibrary("maps");
				const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
				const map = new Map(document.getElementById("map-modal"), {
					center: this.position,
					zoom: this.zoom,
					streetViewControl: false,
					mapTypeControl: false,
					fullscreenControl: false,
					clickableIcons: false,
					mapId: '952e5846ea5cd60b'
				});

				const markerImg = document.createElement("img");
				markerImg.src = this.marker

				const advancedMarker = new AdvancedMarkerElement({
					map,
					position: this.position,
					content: markerImg,
					gmpDraggable: !this.confirmed,
				});

				advancedMarker.addListener('dragend', () => {
					this.zoom = map.zoom
					this.position = advancedMarker.position
					this.localValue = {lat: this.position.lat, lng: this.position.lng, zoom: this.zoom, confirmed: this.confirmed}
					this.handleInput()
				})

				if(this.items) {
					const infowindow = new google.maps.InfoWindow();
					infowindow.setContent(this.windowContent(this.items));

					infowindow.open({
						anchor: advancedMarker,
						map,
					});
				}

			})
		},

		windowContent(item) {
			if(this.type) {
				return `
					<div class="card-map" data-lat="${item?.location?.position?.lat}" data-lng="${item?.location?.position?.lng}" data-id="${item?.id}">
						<div class="status__item">
							<div class="status-label" style="background: ${item?.status[0]?.background}; color: ${item?.status[0]?.color};">
								<svg class="v-svg-icon svg-icon status-label-icon" style="display: ${item?.status[0]?.icon ? 'block' : 'none'}">
									<use href="/local/assets/dist/icons/sprite.svg#svg-icon-${item?.status[0]?.icon}"></use>
								</svg>
								${item?.status[0]?.text ? item?.status[0]?.text : ''}
							</div>
						</div>
						<img class="card-map__image" src="${item?.slides[0]?.src}"/>
						<div class="card-map__info">
							<div class="card-map__price">
								${item?.price?.current?.prefix ? item?.price?.current?.prefix : ''} ${item?.price?.current?.currency ? item?.price?.current?.currency : ''} ${item?.price?.current?.value ? item?.price?.current?.value : ''} ${item?.price?.current?.postfix ? item?.price?.current?.postfix : ''}</div>
							<div class="card-map__title">${item?.title?.text ? item?.title?.text : ''} ${item?.title?.value ? item?.title?.value : ''} ${item?.title?.postfix ? item?.title?.postfix : ''}</div>
						</div>
					</div>`
			} else {
				return `
					<div class="card-map">
						<div class="status__item">
							<div class="status-label" style="background: ${item?.aside?.status[0]?.background}; color: ${item?.aside?.status[0]?.color};">
								<svg class="v-svg-icon svg-icon status-label-icon" style="display: ${item?.aside?.status[0]?.icon ? 'block' : 'none'}">
									<use href="/local/assets/dist/icons/sprite.svg#svg-icon-${item?.aside?.status[0]?.icon}"></use>
								</svg>
								${item?.aside?.status[0]?.text ? item?.aside?.status[0]?.text : ''}
							</div>
						</div>
						<img class="card-map__image" src="${item?.slider?.items[0]?.src}" alt=""/>
						<div class="card-map__info">
							<div class="card-map__price">${item?.aside?.price?.current?.currency ? item?.aside?.price?.current?.currency : ''} ${item?.aside?.price?.current?.value ? item?.aside?.price?.current?.value : ''}  ${item?.aside?.price?.current?.postfix ? item?.aside?.price?.current?.postfix : ''}</div>
							<div class="card-map__title">${item?.title?.text} ${item?.title?.value ? item?.title?.value : ''} ${item?.title?.postfix ? item?.title?.postfix : ''}</div>
						</div>
					</div>`
			}
		},

		handleInput() {
			console.log(this.localValue)
			this.$emit('set-position', this.localValue);
		},

	}
};
</script>